import { render, staticRenderFns } from "./CopyRatePlanForm.vue?vue&type=template&id=37eeb753&scoped=true&"
import script from "./CopyRatePlanForm.vue?vue&type=script&lang=js&"
export * from "./CopyRatePlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eeb753",
  null
  
)

export default component.exports